import Tab from '../../plugins/tab.js';
const elements = document.querySelectorAll(".js-tab");
for (const element of elements) {
  new Tab(element, {
    defaultOpenPanel: 0
  });
}



let url_tab = location.href;
if(url_tab.indexOf("?tab=") != -1){
  let id = url_tab.split("?tab=");
  let tabid = "#" + id[1] + " .js-tab-button";
  //console.log(tabid);
  setTimeout(function(){
    $(tabid).trigger('click');
  }, 200);
  
  //$(tabid).click();
  //document.getElementById(tabid).click();
}


// accordion.init();
// new Tab($(".js-tab"), {
//   defaultOpenPanel: 0
// });

// $(".js-tab").each(function(i, v){
//   var $that = $(this);
//   new Tab($that, {
//     defaultOpenPanel: 0
//   });
// })